import React from "react";
import PropTypes from "prop-types";
import EAButton from "../EAButton";
import "../../styles/components/tablePaginationActions.css"

/**
 * Komponente zur Darstellung der Schaltflächen zum Ändern der ausgewählten Seite
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function EATablePaginationActions(props) {
    const {count, page, rowsPerPage, onPageChange} = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className="gridl tablePaginationActions">
            <EAButton
                id="firstTablePage"
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="Erste Seite"
                label="Erste"
            />
            <EAButton
                id="previousTablePage"
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="Vorherige Seite"
                label="Zurück"
            />
            <EAButton
                id="nextTablePage"
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="Nächste Seite"
                label="Nächste"
            />
            <EAButton
                id="lastTablePage"
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="Letzte Seite"
                label="Letzte"
            />
        </div>
    );
}

EATablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChanged: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default EATablePaginationActions;
